import React from 'react';
import ReactDOM from 'react-dom';
import type { ModalProps } from './Modal';
import { Modal } from './Modal';
import { isEmptyString } from '../../util';

/**
 * A {@link Modal} component which will render itself to the `document.body` using `ReactDOM.createPortal`.
 * The specific use-case for this is meant to be for popup windows which should use the entire
 * page, instead of being constrained to a smaller region like normal {@link Modal} elements.
 *
 * If the element is draggable, then it will automatically set its bounds to the 'body'.
 *
 * @param properties {@link ModalProps}
 * @constructor
 * @return the created {@link JSX.Element}.
 */
export function GlobalModal({
  className = '',
  children,
  draggable = true,
  ...props
}: Readonly<ModalProps>): JSX.Element {
  const classes = ['ehs-global-modal'];
  if (!isEmptyString(className)) {
    classes.push(className);
  }

  return ReactDOM.createPortal(
    <Modal
      {...props}
      className={classes.join(' ').trim()}
      draggable={
        draggable
          ? {
              bounds: 'body',
              ...(typeof draggable === 'object' && draggable)
            }
          : false
      }
    >
      {children}
    </Modal>,
    document.body
  );
}
